import { render, staticRenderFns } from "./ProductSale.vue?vue&type=template&id=295c8ed9&scoped=true&"
import script from "./ProductSale.vue?vue&type=script&lang=js&"
export * from "./ProductSale.vue?vue&type=script&lang=js&"
import style0 from "./ProductSale.vue?vue&type=style&index=0&id=295c8ed9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295c8ed9",
  null
  
)

export default component.exports